/** Governance — overview + focused sub-pages. */

export const GOVERNANCE_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "health", label: "Health" },
  { id: "mdr", label: "MDR" },
  { id: "gates-early", label: "G1–G4" },
  { id: "gates-late", label: "G5–G8" },
  { id: "wave", label: "Wave" },
  { id: "audit", label: "Audit" },
];

export const GOVERNANCE_DRILL = GOVERNANCE_FLOWS.filter((f) => f.id !== "overview");

export const GOVERNANCE_FOCUS_TITLE = {
  overview: "Governance at a glance",
  health: "Modernization health",
  mdr: "MDR authorization",
  "gates-early": "G1–G4 human band",
  "gates-late": "G5–G8 delivery band",
  wave: "Wave eligibility",
  audit: "Audit trail",
};

export const GOVERNANCE_FOCUS_DETAIL = {
  overview: "Health, MDR, gates and wave — one topic per screen.",
  health: "RED/AMBER/GREEN from MDR, wave and open gates — not Jira %.",
  mdr: "Authorization, immutability and version history.",
  "gates-early": "Assessment, decision, architecture and wave readiness.",
  "gates-late": "Security, test, GO, hypercare and G8 success.",
  wave: "Planning eligibility vs G4 wave readiness.",
  audit: "Who · what · why — tenant scoped.",
};

export function resolveGovernanceFocus(explicit) {
  if (!explicit) return "overview";
  const legacy = { gates: "gates-early", govern: "gates-early", plan: "wave", health: "health" };
  return legacy[explicit] || explicit;
}
